import { queryRight } from '@/services/workspace';
import { VIPType } from '@/store/User';
import { VIPWEIGHT } from '@/store/User/const';
import { getCookie } from '@/utils';

/**
 * 获取用户权益身份相关
 * @param consumeCredit
 */
export type UserInfo = VIPType & { overage: number; isExpireUser: boolean };
export const getUserIdentityInfo = async () => {
  return new Promise<UserInfo>((resolve, reject) => {
    queryRight()
      .then((res) => {
        let result = {
          overage: 0,
          key: 'freeVip',
          title: 'free',
          isExpire: false,
          weight: VIPWEIGHT.freeVip,
          startTime: 0,
          endTime: 0,
          vipSource: 0,
          isExpireUser: false,
        } as UserInfo;
        // 金额（秒）
        let overageData = res.data.find(
          (item: any) => item.key === 'clipDuration' || item.key === 'clipDuration\t',
        ) || {
          leftValue: 0,
        };
        let isOldData = res.data.every((item: any) => {
          return !['freeVip', 'basicVip', 'advancedVip', 'enterpriseVip'].includes(
            item.key,
          );
        });
        if (isOldData) {
          // 旧数据，没有身份标识，统一为免费用户
          result = {
            overage: Number((overageData.leftValue / 60).toFixed(1)),
            key: 'freeVip',
            title: 'free',
            isExpire: false,
            weight: VIPWEIGHT.freeVip,
            startTime: 0,
            endTime: 0,
            vipSource: 0,
            isExpireUser: res.isExpireUser || false,
          };
          resolve(result);
        } else {
          if (res.data && res.data.length) {
            // 余额
            result.overage = Number((overageData.leftValue / 60).toFixed(1));
            result.isExpireUser = res.isExpireUser || false;
            res.data.forEach((member: VIPType) => {
              // 未过期的大于免费用户的就是当前的
              if (!member.isExpire && VIPWEIGHT[member.key] > result.weight) {
                result.key = member.key;
                result.title = member.title;
                result.weight = VIPWEIGHT[member.key];
                result.isExpire = member.isExpire;
                result.startTime = member.startTime;
                result.endTime = member.endTime;
                result.vipSource = 0;
              }
            });
            resolve(result);
          } else {
            reject();
          }
        }
      })
      .catch(() => {
        reject({ type: 'userInfo' });
      });
  });
};

function formatData(
  data: Array<{ orderId?: string; isFree?: boolean; [key: string]: any }>,
) {
  let obj = {
    payment_id: '',
    redeem: '',
    configure: false,
  };
  data.forEach((item) => {
    const orderId = item.orderId;
    const freeTitle = new Set(['免费时长10点', '免费导出视频时长', 'free']);
    if (freeTitle.has(item.title) && item.commodityCode) {
      // return '免费权益';
    } else if (orderId) {
      if (
        /^[A-Z0-9]{8}$/.test(orderId) ||
        /^20004:[A-Z0-9]{7}:[0-9]+:[a-z]+$/.test(orderId)
      ) {
        // '兑换码';
        obj.redeem = orderId;
      } else if (!item.commodityCode) {
        //  '权益后台配置';
        obj.configure = true;
      } else {
        // '线上购买';
        obj.payment_id = orderId;
      }
    } else {
      // return '权益后台配置';
      obj.configure = true;
    }
  });
  return obj;
}

export const getUserCredit = async () => {
  try {
    const userAuth = getCookie('user');
    const appKey = '10000100';
    const salt = window.btoa(appKey);
    const response = await fetch('/api/creditInfo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        salt,
        appKey,
        token: userAuth.token,
        uid: userAuth.uid,
      }),
    });
    const result = await response.json();
    if (result?.code === 200 && result.data) {
      const targetArray = result.data.filter((item: any) => item.key === 'clipDuration');
      return formatData(targetArray);
    } else {
      return {};
    }
  } catch (error) {}
};
